import React from 'react'

const About = () => {
 return (
 <section id="about" className="section" style={{ background: 'rgba(255,107,139,0.02)' }}>
 <div className="container">
 <h2 className="section-title">关于甜蜜时光</h2>
 <p className="section-subtitle">
我们致力于将甜蜜与幸福传递给每一位顾客 </p>
 <div style={{
 display: 'grid',
 gridTemplateColumns: '1fr 1fr',
 gap: '60px',
 alignItems: 'center'
 }}>
 <div>
 <div style={{
 background: 'var(--white)',
 padding: '40px',
 borderRadius: '20px',
 boxShadow: 'var(--shadow)'
 }}>
 <h3 style={{
 fontSize: '1.5rem',
 fontWeight: '600',
 marginBottom: '24px',
 color: 'var(--text-dark)'
 }}>
我们的故事 </h3>
 <p style={{
 color: 'var(--text-light)',
 lineHeight: '1.8',
 marginBottom: '20px'
 }}>
甜蜜时光蛋糕店成立于2015年，由一群热爱烘焙的年轻人创立。我们相信，每一款蛋糕都承载着美好的回忆和真挚的情感。
 </p>
 <p style={{
 color: 'var(--text-light)',
 lineHeight: '1.8',
 marginBottom: '20px'
 }}>
从原料的选择到制作的每一个环节，我们都严格把控品质，只为给您带来最纯正的甜蜜体验。
 </p>
 <div style={{
 display: 'grid',
 gridTemplateColumns: '1fr 1fr',
 gap: '20px',
 marginTop: '30px'
 }}>
 <div style={{ textAlign: 'center' }}>
 <div style={{
 fontSize: '2rem',
 fontWeight: '700',
 color: 'var(--primary)',
 marginBottom: '8px'
 }}>
8年+
 </div>
 <div style={{ color: 'var(--text-light)', fontSize: '0.875rem' }}>
烘焙经验 </div>
 </div>
 <div style={{ textAlign: 'center' }}>
 <div style={{
 fontSize: '2rem',
 fontWeight: '700',
 color: 'var(--primary)',
 marginBottom: '8px'
 }}>
10000+
 </div>
 <div style={{ color: 'var(--text-light)', fontSize: '0.875rem' }}>
满意客户 </div>
 </div>
 </div>
 </div>
 </div>
 <div style={{
 display: 'flex',
 flexDirection: 'column',
 gap: '20px'
 }}>
 <div style={{
 background: 'var(--white)',
 padding: '30px',
 borderRadius: '20px',
 boxShadow: 'var(--shadow)',
 textAlign: 'center'
 }}>
 <div style={{
 width: '60px',
 height: '60px',
 background: 'linear-gradient(135deg, var(--primary), var(--secondary))',
 borderRadius: '50%',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 margin: '0 auto 16px',
 color: 'white',
 fontSize: '24px'
 }}>
 🌟 </div>
 <h4 style={{
 fontSize: '1.125rem',
 fontWeight: '600',
 marginBottom: '8px',
 color: 'var(--text-dark)'
 }}>
精选原料 </h4>
 <p style={{ color: 'var(--text-light)', fontSize: '0.875rem' }}>
只选用优质进口奶油和新鲜水果，确保每一口都是纯正美味 </p>
 </div>
 <div style={{
 background: 'var(--white)',
 padding: '30px',
 borderRadius: '20px',
 boxShadow: 'var(--shadow)',
 textAlign: 'center'
 }}>
 <div style={{
 width: '60px',
 height: '60px',
 background: 'linear-gradient(135deg, var(--primary), var(--secondary))',
 borderRadius: '50%',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 margin: '0 auto 16px',
 color: 'white',
 fontSize: '24px'
 }}>
 👨‍🍳 </div>
 <h4 style={{
 fontSize: '1.125rem',
 fontWeight: '600',
 marginBottom: '8px',
 color: 'var(--text-dark)'
 }}>
专业烘焙 </h4>
 <p style={{ color: 'var(--text-light)', fontSize: '0.875rem' }}>
经验丰富的烘焙师团队，每一款蛋糕都经过精心设计和制作 </p>
 </div>
 <div style={{
 background: 'var(--white)',
 padding: '30px',
 borderRadius: '20px',
 boxShadow: 'var(--shadow)',
 textAlign: 'center'
 }}>
 <div style={{
 width: '60px',
 height: '60px',
 background: 'linear-gradient(135deg, var(--primary), var(--secondary))',
 borderRadius: '50%',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 margin: '0 auto 16px',
 color: 'white',
 fontSize: '24px'
 }}>
 🚚 </div>
 <h4 style={{
 fontSize: '1.125rem',
 fontWeight: '600',
 marginBottom: '8px',
 color: 'var(--text-dark)'
 }}>
新鲜配送 </h4>
 <p style={{ color: 'var(--text-light)', fontSize: '0.875rem' }}>
专业冷链配送，确保蛋糕在最佳状态下送达您的手中 </p>
 </div>
 </div>
 </div>
 </div>
 </section>
 )
}

export default About